import { Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { AlignLeftOutlined, BookOutlined } from '@ant-design/icons';
import { omit } from 'lodash';
import BookingTable from './BookingTable';
import CreateRequestBooking from './CreateRequestBooking';

const BookingsTabs = () => {
    const [currentTab] = useState('0');

    const items = [
        {
            label: (
                <span>
                    <BookOutlined /> New Booking
                </span>
            ),
            children: <CreateRequestBooking />,
            key: '0',
            disabled: false,
        },
        {
            label: (
                <span>
                    <AlignLeftOutlined /> Latest Bookings
                </span>
            ),
            children: <BookingTable />,
            key: '1',
        },
    ];

    return (
        <>
            <Tabs defaultActiveKey={currentTab} items={items} />
        </>
    );
};

export default BookingsTabs;
